// ** 全局翻译助手 L
// 源码以中文为基准文案；L() 依据当前语言（zh/en/id）从词典返回对应译文。
// - 当前语言为中文时直接原样返回（零开销）
// - 词典未收录的文案回退为原文（保证任何情况不显示空白）
// - 同时挂到 window.L，供被 i18n-transform.js 转换后的源码直接调用
import i18n from '../configs/i18n'

// 语言归一化：zh-CN / zh-Hans -> zh；id-ID -> id；其余 -> en
export const normalizeLng = (lng) => {
  if (!lng) return 'zh'
  lng = String(lng).toLowerCase()
  if (lng.startsWith('zh')) return 'zh'
  if (lng.startsWith('id') || lng.startsWith('in')) return 'id'
  return 'en'
}

const L = (text) => {
  if (typeof text !== 'string' || !text) return text
  const lng = normalizeLng(i18n.language)
  if (lng === 'zh') return text
  const translated = i18n.t(text, { defaultValue: text })
  return typeof translated === 'string' && translated ? translated : text
}

export default L

// 供转换后的源码以全局标识符方式调用（配合 /* global L */ 注释）
if (typeof window !== 'undefined') {
  window.L = L
}
